'use client';

import Link from 'next/link';
import { ArrowLeft } from 'lucide-react';

export default function TermosPage() {
  return (
    <div className="min-h-screen bg-gradient-to-b from-gray-900 to-black text-white">
      <div className="container mx-auto px-4 py-12 max-w-3xl">
        {/* Voltar */}
        <Link 
          href="/" 
          className="inline-flex items-center gap-2 text-gray-400 hover:text-white mb-8 transition-colors"
        >
          <ArrowLeft className="w-4 h-4" />
          Voltar
        </Link>

        {/* Banner preliminar */}
        <div className="bg-yellow-500/10 border border-yellow-500/30 rounded-lg p-4 mb-8">
          <p className="text-yellow-400 text-sm">
            📋 Este documento é preliminar e será atualizado com a versão final antes do lançamento oficial.
          </p>
        </div>

        <h1 className="text-3xl font-bold mb-8">Termos de Uso</h1>
        
        <div className="prose prose-invert prose-gray max-w-none space-y-6">
          <p className="text-gray-300">
            Última atualização: Janeiro de 2026
          </p>

          <section>
            <h2 className="text-xl font-semibold text-white mt-8 mb-4">1. Aceitação dos Termos</h2>
            <p className="text-gray-300">
              Ao acessar e usar o Atende Turbo, você concorda com estes Termos de Uso. 
              Se você não concordar com qualquer parte destes termos, não poderá usar nossos serviços.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-white mt-8 mb-4">2. Descrição do Serviço</h2>
            <p className="text-gray-300">
              O Atende Turbo é uma plataforma de atendimento automatizado via WhatsApp que utiliza 
              inteligência artificial para responder mensagens de clientes em nome do seu negócio.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-white mt-8 mb-4">3. Uso Permitido</h2>
            <p className="text-gray-300">
              Você concorda em usar o serviço apenas para fins comerciais legítimos e em conformidade 
              com as políticas do WhatsApp Business. É proibido:
            </p>
            <ul className="list-disc list-inside text-gray-300 mt-2 space-y-1">
              <li>Enviar spam ou mensagens não solicitadas</li>
              <li>Usar para atividades ilegais ou fraudulentas</li>
              <li>Violar direitos de terceiros</li>
              <li>Tentar acessar sistemas sem autorização</li>
            </ul>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-white mt-8 mb-4">4. Conta e Segurança</h2>
            <p className="text-gray-300">
              Você é responsável por manter a confidencialidade das suas credenciais de acesso 
              e por todas as atividades realizadas em sua conta.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-white mt-8 mb-4">5. Pagamentos e Cancelamento</h2>
            <p className="text-gray-300">
              Os planos são cobrados mensalmente ou anualmente, conforme sua escolha. 
              Você pode cancelar a qualquer momento, mantendo acesso até o fim do período pago.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-white mt-8 mb-4">6. Limitação de Responsabilidade</h2>
            <p className="text-gray-300">
              O Atende Turbo é fornecido &quot;como está&quot;. Não garantimos disponibilidade ininterrupta 
              ou que o serviço atenderá todas as suas necessidades específicas.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-white mt-8 mb-4">7. Contato</h2>
            <p className="text-gray-300">
              Para dúvidas sobre estes termos, entre em contato: suporte@atendeturbo.com.br
            </p>
          </section>
        </div>

        {/* Footer */}
        <div className="mt-12 pt-8 border-t border-gray-800 text-center text-gray-500 text-sm">
          <p>© 2026 Atende Turbo. Todos os direitos reservados.</p>
        </div>
      </div>
    </div>
  );
}
